<template>
  <div v-if='isOpen' class="fixed z-20 inset-0 w-screen h- bg-black">

    <div class="mt-2 p-2">
      <carousel
        navigationEnabled
        :paginationEnabled="false"
        :navigateTo='navigateToIndex'
        :perPage='1'>
        <slide v-for='img in images' v-bind:key='img'>
          <img :src="img+'.jpg'" />
        </slide>
      </carousel>
    </div>

    <div class="absolute top-0 right-0 pt-8 pr-6 cursor-pointer" @click='onClose'>
      <img src='/images/close.svg' class="close-button"/>
    </div>
    <div
      class="slider-caret absolute px-4 left-0 cursor-pointer" @click='onPrevious'>
      <img src='/images/caret-left.svg' />
    </div>
    <div
      class="slider-caret absolute px-4 right-0 cursor-pointer" @click='onNext'>
      <img src='/images/caret-right.svg' />
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'ModalGallery',

  props: {
    images: Array,
    isOpen: Boolean,
    navigateTo: Number,
  },

  data () {
    return {
      navigateToIndex: this.navigateTo,
    }
  },

  computed: {
    isFirst() {
      return this.navigateToIndex == 0
    },
    isLast () {
      return this.navigateToIndex == this.images.length - 1
    }
  },

  watch: {
    navigateTo (newVal) {
      this.navigateToIndex = newVal
    }
  },

  components: {
    Carousel,
    Slide
  },

  methods: {
    onClose () {
      this.$emit('on-close')
    },
    onPrevious () {
      if (this.isFirst) {
        this.navigateToIndex = this.images.length - 1
      } else {
        this.navigateToIndex = Math.max(0, this.navigateToIndex - 1)
      }
    },
    onNext () {
      if (this.isLast) {
        this.navigateToIndex = 0
      } else {
        this.navigateToIndex = Math.min(this.images.length - 1, this.navigateToIndex + 1)
      }
    }
  }
}
</script>

<style>
  .slider-caret {
    top: 50%;
    transform: translateY(-50%);
  }
  .VueCarousel-slide {


  }
  .VueCarousel-slide img{
    max-height:95vh;
    margin:auto;
  }

</style>
